// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"style-module__fadeIn___18pTa","skillSelect":"style-module__skillSelect___2H5_A"};